import { navigate } from 'gatsby';
import React from 'react';

import * as ROUTES from '@constants/routes';

import { formatTime } from '@utils/format';

import {
  AllData,
  Description,
  RoutineListItemDiv,
  Time,
  Title,
} from './RoutineListItem.style';

export const RoutineList: React.FC<{
  id?: string | null;
  time?: number;
  description?: string | null;
  name?: string | null;
}> = ({ id, time, description = '', name = '' }) => {
  return (
    <RoutineListItemDiv
      onClick={() => {
        navigate(`${ROUTES.ROUTINES}${id}`);
      }}
    >
      <AllData>
        <Time>{formatTime(time)}</Time>
        <Title>{name}</Title>
        <Description>{description}</Description>
      </AllData>
    </RoutineListItemDiv>
  );
};

export default RoutineList;
